<template>
    <FaqThemes />
</template>
<script>
import FaqThemes from '@/components/FaqThemes.vue';

export default {
    components: {
        FaqThemes
    },
}
</script>
